const EVENT_SPLIT_CHAR = '\n';
export const getLatestEvent = (serverEvent: string): string => {
  if (typeof serverEvent === 'object') {
    serverEvent = JSON.stringify(serverEvent);
  }
  serverEvent = typeof serverEvent !== 'string' ? JSON.parse(serverEvent) : serverEvent;
  const events = serverEvent.split(EVENT_SPLIT_CHAR).filter((line: string) => line.length > 0);
  if (events.length === 0) return '';
  return events[events.length - 1];
};

export const getEvents = (serverEvent: string): string[] => {
  return serverEvent.split(EVENT_SPLIT_CHAR).filter((line: string) => line.length > 0);
};
